// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + {"16":"app-public","180":"app-main","532":"styles","918":"app-embed"}[chunkId] + ".css?" + {"16":"12ae1e2a106875245af2","180":"1635fb4493328b16e423","532":"68da5486e880d14b306e","918":"12ae1e2a106875245af2"}[chunkId] + "";
};